<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">線上點餐管理 / POS套餐管理</b-col>
      <b-col>
      </b-col>
    </b-row>

    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;" visible>
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row mt-3">
                  <label class="control-label col-md-2">品牌：</label>
                    <div class="col-md-3">
                       <select
                          id="queryBrandsCode"
                          name="queryBrandsCode"
                          class="form-control"
                          v-model="search.queryBrandsCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                        </select>
                    </div>
                    <label class="control-label col-md-3">套餐名稱：</label>
                    <div class="col-md-3">
                      <input type="text" class="form-control" v-model="search.name" placeholder="請輸入關鍵字搜尋">
                    </div>
                </div>
                  <div class="row mt-3 mb-3">
                  <label class="control-label col-md-2">套餐代碼：</label>
                  <div class="col-md-3">
                    <input type="text" class="form-control" v-model="search.code" placeholder="請輸入代碼搜尋">
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                    <button type="button" class="btn btn-ptc1" @click="reset">重設</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <h3></h3>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordred table-striped">
                        <thead>
                          <tr>
                            <th>項次</th>
                            <th>品牌</th>
                            <th>圖片</th>
                            <th>套餐名稱</th>
                            <th>套餐代碼</th>
                            <th>POS分類</th>
                            <th>POS金額</th>
                            <th>最低金額</th>
                            <!-- <th></th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in items" :key="x.ID" :id="x.ID">
                            <td>{{search.pageRows * (search.currentPage - 1) + index + 1}}</td>
                            <td>{{x.BrandCode}}</td>
                            <td><img height="140px" :src="POS_URL + x.ImageURL"></td>
                            <td>{{x.Name}}</td>
                            <td>{{x.Code}}</td>
                            <td>{{x.AttributeName}}</td>
                            <td>{{x.Price}}</td>
                            <td>{{x.AppPrice}}</td>
                            <!-- <td>
                              <button v-b-tooltip.hover.top title="預覽" class="btn-circle btn-circle-ptc1" @click="showDetail(x)"><span class="fa fa-search-plus"></span></button>
                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="row" style="padding: 0 1rem">
                      <b-pagination size="md" :total-rows="search.totalRows" v-model="search.currentPage" :per-page="search.pageRows" @change="changePage"></b-pagination>
                      <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalRows}}筆</label>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL,POS_URL,POS_FCM_URL,BRAND_MWD} from '../../../store/root.js'
import { DEFAULT_SEARCH_BRAND_CODE } from '@/constants/defaultValues.js'
import miniToastr from 'mini-toastr'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      search: {
        code: '',
        name: '',
        currentPage: 1,
        pageRows: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0,
        queryBrandsCode: DEFAULT_SEARCH_BRAND_CODE,
      },
      totalRows: 0,
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      API_URL: API_URL,
      POS_URL: POS_URL,
      FunctionPermission: 0,
      lists: [],
      selectListBrands: []
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F17') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }
    this.querySelectListBrands()
    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
      console.log(this.search)
      this.query()
    } else {
      this.reset()
    }
  },
  methods: {
    reset () {
      this.search.code = ''
      this.search.name = ''
      this.search.currentPage = 1
      this.search.queryBrandsCode = DEFAULT_SEARCH_BRAND_CODE

      this.query()
    },
    btnQuery () {
      if (this.search.queryBrandsCode==BRAND_MWD) {
        this.POS_URL = POS_URL
      } else {
        this.POS_URL = POS_FCM_URL
      }
      this.search.currentPage = 1
      this.query()
    },
    query () {
      var name, code, page, pageRows, brandCode

      name = this.search.name
      code = this.search.code
      page = this.search.currentPage
      pageRows = this.search.pageRows
      brandCode = this.search.queryBrandsCode

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getpageposcombo/v1', {
        code: code,
        name: name,
        page: page,
        pageRows: pageRows,
        brandCode: brandCode
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.items = response.data.data
            this.search.totalRows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = this.search.currentPage // 分頁處理 : 從編輯頁回列表時，跳回目前分頁
            this.search.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.search.pageRows * (this.search.currentPage - 1) + 1;
            this.search.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.search.pageRows > response.data.count) ? response.data.count : (this.search.currentPage * this.search.pageRows) >= response.data.count ? response.data.count : this.search.currentPage * this.search.pageRows;
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    changePage (page) {
      this.search.currentPage = page
      this.query()
    },
    querySelectListBrands() {
      axios.post(API_URL + "/web/brands/v1", {
        all: false,
        order: true
      })

      .then(response => {
        this.selectListBrands = response.data.data;
        this.$parent.Loading = false;
        })

      .catch(error => {
        this.selectListBrands = [];
        this.$parent.Loading = false;
        miniToastr.error(error, "資料讀取異常");
        console.log(error);
      })
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/posCombo/List.vue